import React, { Component, Fragment} from 'react';
import {connect} from 'react-redux';

import './CmsPage.module.scss';

import WebsiteFooter from 'components/UI/WebsiteFooter/WebsiteFooter';
import WebsiteHeader from 'components/UI/WebsiteHeader/WebsiteHeader';


//import page components
import Image        from 'components/UI/PageComponents/image/Image';
import TextBlock    from 'components/UI/PageComponents/TextBlock/TextBlock';
import Title        from 'components/UI/PageComponents/Title/Title';
import Button       from 'components/UI/PageComponents/Button/Button';
import Video        from 'components/UI/PageComponents/Video/Video';

import Accordion from '../../components/UI/Accordion/Accordion';
/**
 * import components
 */

import indexPage from 'actions/page/index';


const mapStateToProps = (state, props) => {
    return {
        pages: state.page.entities,
    };
};

const mapDispatchToProps = {
    indexPage
};


class CmsPage extends Component {

    
    constructor() {
        super();
    }

    componentDidMount() {
        this.props.indexPage();
    }

    componentDidUpdate(prevProps) {
        if(this.props.match.params.page != prevProps.match.params.page) {
            this.props.indexPage();
        }
    }

    render() {

        let currentPage = this.props.pages.allIds.map((pageId) => this.props.pages.byId[pageId]).find(page => page.url == this.props.match.params.page);

        return (
            <Fragment>
                <div styleName='page'>
                    <div styleName='top'>
                        <WebsiteHeader/>
                        <div styleName='content'>
                            {
                                currentPage ?
                                currentPage.content.map(function(item, i){
                                    if(item.layout == 'image'){
                                        return(
                                            <Image key={i} item={item.attributes} />
                                        );
                                    }
                                    if(item.layout == 'text'){
                                        return(
                                            <TextBlock key={i} content={item.attributes.text} />
                                        );
                                    }
                                    if(item.layout == 'title'){
                                        return(
                                            <Title key={i} title={item.attributes.title} />
                                        );
                                    }
                                    if(item.layout == 'button'){
                                        return(
                                            <Button key={i} item={item.attributes} />
                                        );
                                    }
                                    if(item.layout == 'video'){
                                        return(
                                            <Video key={i} item={item.attributes}/>
                                        );
                                    }
                                    if(item.layout == 'folddown_menu'){
                                        return(
                                            <Accordion key={i} title={item.attributes.title}>
                                                
                                                {
                                                    item.attributes.folddown_content &&
                                                    item.attributes.folddown_content.map(function(item2, i2){
                                                        if(item2.layout == 'image'){
                                                            return(
                                                                <Image key={i2} item={item2.attributes}/>
                                                            );
                                                        }
                                                        if(item2.layout == 'text'){
                                                            return(
                                                                <TextBlock key={i2} content={item2.attributes.text} />
                                                            );
                                                        }
                                                        if(item2.layout == 'title'){
                                                            return(
                                                                <Title key={i2} title={item2.attributes.title} />
                                                            );
                                                        }
                                                        if(item2.layout == 'button'){
                                                            return(
                                                                <Button key={i2} item={item2.attributes} />
                                                            );
                                                        }
                                                        if(item2.layout == 'video'){
                                                            return(
                                                                <Video key={i2} item={item2.attributes}/>
                                                            );
                                                        }
                                                    }, this)
                                                } 
                                            </Accordion>
                                        );
                                    }
                                }, this)
                                :
                                <Fragment><p>Hier kan een leuke 404 melding</p></Fragment>
                            } 
                        </div>
                    </div>
                    <WebsiteFooter/>
                </div>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CmsPage);